import Layout from "../components/layout"

const PrivacyPolicy = () => {
  return (
    <Layout>
      <div className="section section--big section--bg-world">
        <div className="wrapper">
          <div className="headline">Gizlilik Politikası</div>
        </div>
      </div>
      <div className="section">
        <div className="wrapper">
          <div className="generic-content-container">
            <p>
              Site üzerinde oluşturduğunuz CV’niz aktif durumda ise üye firmalarımız veritabanı içerisinde yaptıkları aramalarda Cv’nize her an ulaşabilirler. Eğer iş arayışınıza
              ara verdiyseniz ve üye firmaların veritabanı içinde yaptıkları aramalarda size ulaşmalarını engellemek isterseniz Cv’nizi pasif hale getirebilirsiniz. Cv’nizin pasif
              olduğu durumda hiçbir üye firma Cv’nize ulaşamaz. Aynı zamanda bu durumlarda kısa bir süre Cv’nizi aktif ederek dileğiniz ilana başvuru yapabilirsiniz. Dolayısıyla
              sadece ilanına başvuru yaptığınız firma tarafından Cv’niz incelenecektir.{" "}
            </p>
            Eğer iskibris.com’da kullandığınız şifrenizin başkası tarafından kullanıldığından şüphe ediyorsanız şifrenizi değiştirebilirsiniz.
            <br />
            Kullanıcılara ait bilgiler sadece üye firmalarımız ve ticari amaçlarla yasal çerçevede bilgilerinizi paylaştığımız kişi ve kurumlar tarafından görülmektedir. Bu sitede
            paylaştığınız bilgiler üyelerimize iş ve işçi arayışlarında yardımcı olmak amacıyla ve reklam, tanıtım ve pazarlama amacıyla kullanılmaktadır. Bilgileriniz iş
            arayışlarında yardımcı olmak amacıyla ve reklam, tanıtım ve pazarlama faaliyetlerinde kullanılmak amacıyla Bankalar vs. 3. Kişilerle paylaşılabilir ve iskibris.com
            tarafından ve/veya bilgilerin paylaşıldığı kişilerce işlenebilir. Bunun sonucu olarak kişisel bilgileriniz iş ve işçi arayışlarında ve reklam, tanıtım ve pazarlama
            faaliyetlerinde kullanılabilir ve bu amaçlarla tarafınıza sms, mail, telefon vs. yollardan ulaşılıp bilgilendirme yapılabilir. <br />
            iskibris.com’da yer alan bilgilerinizi istediğiniz zaman değiştirebilir ve tüm kişisel bilgilerinizin silinmesini ya da bilgilendirme yapılan kanal üzerinden, size sms,
            mail, telefon vs. yollardan ulaşılıp bilgilendirme yapılmamasını sağlayabilirsiniz.
            <br />
            Yukarıda tarafıma aktarılan bilgileri okudum ve anladım. Bu sitede paylaştığınız bilgilerin İş Kıbrıs tarafından yukarıda sayılan amaçlarla, ÜYE FİRMALAR HARİCİNDE ve
            üçüncü kişilerle paylaşılmasını ve bilgilerimin iskibris.com ve uygun gördüğü 3. Kişiler tarafından işlenmesini; <br />
            iskibris.com’a gösterdiğiniz ilgi ve güvene teşekkür ederiz.
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default PrivacyPolicy
